var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import merge from 'lodash/merge';
import { getFWReferrerFromURL, uuidv4 } from '@embed/helpers';
import { getSession } from '@embed/store/session';
import { sendPixelTrackingWithSession } from '@embed/store/tools/tracking';
import cookies from '@src/embeds/utils/cookies';
export function fwnAnalytics() {
    const Proto = {
    //
    };
    Object.defineProperty(Proto, 'write', {
        value: function ({ key, value, duration = 0, }) {
            cookies.set({
                name: key,
                value: value,
                expirationDate: new Date(new Date().getTime() + duration * 1000),
                domain: '',
            });
        },
        writable: false,
    });
    Object.defineProperty(Proto, 'read', {
        value: function ({ key }) {
            var _a;
            return (_a = cookies.get({ name: key })) !== null && _a !== void 0 ? _a : '';
        },
        writable: false,
    });
    Object.defineProperty(Proto, 'track', {
        value: function (event, data) {
            return __awaiter(this, void 0, void 0, function* () {
                sendPixelTrackingWithSession({
                    url: `/trk/user:${event}`,
                    data: merge({
                        event_properties: {
                            _last_channel_id: this.last_channel_id,
                            _last_livestream_id: this.last_livestream_id,
                            _last_video_id: this.last_video_id,
                        },
                    }, data),
                    host: undefined,
                });
            });
        },
    });
    Object.defineProperty(Proto, 'last_channel_id', {
        set: function (value) {
            this.write({
                key: '_fwnlstchnlid',
                value: value,
                duration: 30 * 24 * 60 * 60, // 30 days
            });
        },
        get: function () {
            return this.read({ key: '_fwnlstchnlid' });
        },
    });
    Object.defineProperty(Proto, 'last_livestream_id', {
        set: function (value) {
            this.write({
                key: '_fwnlstlvstrmid',
                value: value,
                duration: 30 * 24 * 60 * 60, // 30 days
            });
        },
        get: function () {
            return this.read({ key: '_fwnlstlvstrmid' });
        },
    });
    Object.defineProperty(Proto, 'last_video_id', {
        set: function (value) {
            this.write({
                key: '_fwnlstvdeoid',
                value: value,
                duration: 30 * 24 * 60 * 60, // 30 days
            });
        },
        get: function () {
            return this.read({ key: '_fwnlstvdeoid' });
        },
    });
    Object.defineProperty(Proto, 'guest_id', {
        get: () => __awaiter(this, void 0, void 0, function* () { var _a; return (_a = (yield getSession()).session) === null || _a === void 0 ? void 0 : _a.guest_id; }),
    });
    Object.defineProperty(Proto, 'session_id', {
        get: () => __awaiter(this, void 0, void 0, function* () { var _b; return (_b = (yield getSession()).session) === null || _b === void 0 ? void 0 : _b.id; }),
    });
    Object.defineProperty(Proto, 'session_referrer', {
        get: () => __awaiter(this, void 0, void 0, function* () { var _c; return (_c = (yield getSession()).session) === null || _c === void 0 ? void 0 : _c.referrer; }),
    });
    Object.defineProperty(Proto, 'page_load_id', {
        value: uuidv4(),
        writable: false,
    });
    const fwreferrer = getFWReferrerFromURL(window.location.href);
    Object.defineProperty(Proto, 'fwreferrer_origin', {
        set: function (value) {
            value &&
                this.write({
                    key: '_fwnfwrfrrorgn',
                    value: value,
                    duration: 30 * 24 * 60 * 60, // 30 days
                });
        },
        get: function () {
            return (this.read({ key: '_fwnfwrfrrorgn' }) ||
                (this.fwreferrer_origin = fwreferrer === null || fwreferrer === void 0 ? void 0 : fwreferrer.origin));
        },
    });
    Object.defineProperty(Proto, 'fwreferrer_channel_id', {
        set: function (value) {
            value &&
                this.write({
                    key: '_fwnfwrfrrchnlid',
                    value: value,
                    duration: 30 * 24 * 60 * 60, // 30 days
                });
        },
        get: function () {
            return (this.read({ key: '_fwnfwrfrrchnlid' }) ||
                (this.fwreferrer_channel_id = fwreferrer === null || fwreferrer === void 0 ? void 0 : fwreferrer.channel_id));
        },
    });
    Object.defineProperty(Proto, 'fwreferrer_video_id', {
        set: function (value) {
            value &&
                this.write({
                    key: '_fwnfwrfrrvidid',
                    value: value,
                    duration: 30 * 24 * 60 * 60, // 30 days
                });
        },
        get: function () {
            return (this.read({ key: '_fwnfwrfrrvidid' }) ||
                (this.fwreferrer_video_id = fwreferrer === null || fwreferrer === void 0 ? void 0 : fwreferrer.video_id));
        },
    });
    Object.defineProperty(Proto, 'fwreferrer_guest_id', {
        set: function (value) {
            value &&
                this.write({
                    key: '_fwnfwrfrrgstid',
                    value: value,
                    duration: 30 * 24 * 60 * 60, // 30 days
                });
        },
        get: function () {
            return (this.read({ key: '_fwnfwrfrrgstid' }) ||
                (this.fwreferrer_guest_id = fwreferrer === null || fwreferrer === void 0 ? void 0 : fwreferrer.guest_id));
        },
    });
    const Analytics = Object.create(Proto);
    Object.defineProperty(Analytics, 'push', {
        value: function (data) {
            // eslint-disable-next-line no-console
            const event = data === null || data === void 0 ? void 0 : data.event;
            this.track(event, {
                event_properties: { user_data: data },
            });
        },
        writable: false,
    });
    return Analytics;
}
